import { render, staticRenderFns } from "./AssignWorkstation.vue?vue&type=template&id=e50a9e78&"
import script from "./AssignWorkstation.vue?vue&type=script&lang=js&"
export * from "./AssignWorkstation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports